import React, { Component } from 'react'
import Autosuggest from 'react-autosuggest'
import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'
import PropTypes from 'prop-types'
import { debounce } from 'utils/debounce'
import { WORD_SEARCH_THEME } from 'constants/formElements'
import 'scss/5_components/_autocomplete.scss'

const renderSuggestion = (suggestion, { query }) => {
  const suggestionFullName = `${suggestion.firstName} ${suggestion.lastName}`
  const matches = match(suggestionFullName, query)
  const parts = parse(suggestionFullName, matches)
  return (
    <>
      {parts.map(part => {
        const className = part.highlight ? 'b' : null
        return (
          <span className={className} key={part.text}>
            {part.text}
          </span>
        )
      })}
      &nbsp;({suggestion.id})
    </>
  )
}

const shouldRenderSuggestions = () => true

/** @deprecated Create an abstraction of <AutocompleteBase /> in Transfix UI instead */
export class SuggestDispatcher extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.presetValue || '',
      suggestions: [],
    }
    this.debouncedLoadSuggestions = debounce(this.loadSuggestions, 400)
    this.onChange = this.onChange.bind(this)
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this)
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this)
    this.getSuggestionValue = this.getSuggestionValue.bind(this)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(props) {
    this.setState({
      value: props.presetValue || '',
      suggestions: [],
    })
  }

  onChange(event, { newValue }) {
    this.setState({ value: newValue })
  }

  onSuggestionsFetchRequested({ value }) {
    this.debouncedLoadSuggestions(value)
  }

  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] })
  }

  getSuggestionValue(suggestion) {
    const { onChange } = this.props
    onChange({ id: suggestion.id })
    return `${suggestion.firstName} ${suggestion.lastName}`
  }

  loadSuggestions(value) {
    const { dispatcherList } = this.props
    const dispatchers = dispatcherList.filter(dispatcher =>
      `${dispatcher.firstName} ${dispatcher.lastName}`.toLowerCase().includes(value.toLowerCase())
    )
    this.formatSuggestions(dispatchers)
  }

  formatSuggestions(suggestions) {
    this.setState({ suggestions })
  }

  render() {
    const { suggestions, value } = this.state
    const inputProps = {
      placeholder: 'Select a Dispatcher',
      value,
      suggestions,
      onChange: this.onChange,
    }

    return (
      <Autosuggest
        theme={WORD_SEARCH_THEME}
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
        shouldRenderSuggestions={shouldRenderSuggestions}
      />
    )
  }
}

SuggestDispatcher.propTypes = {
  onChange: PropTypes.func,
  dispatcherList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    })
  ),
  presetValue: PropTypes.string,
}

SuggestDispatcher.defaultProps = {
  onChange: () => {},
  dispatcherList: [],
  presetValue: '',
}
